var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-container max-w-md mx-auto"},[_c('div',{staticClass:"rounded-lg bg-gray-100 p-10"},[(_vm.success)?_c('div',[_c('h1',{staticClass:"text-2xl text-green-500 text-center font-bold"},[_vm._v("Contract successfully decline")]),_c('div',{staticClass:"text-sm text-center"},[_vm._v("Redirecting...")])]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }